import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const turkeyDoctors = [
  {
    id: "savas-tuna",
    name: "Prof. Dr. Savaş Tuna",
    specialty: "General Surgery",
    experience: "35",
    image: "/images/image copy 42.png",
    description:
      "Expert in advanced laparoscopic and gastrointestinal surgeries.",
    qualifications: "MD, PhD in General Surgery",
    about:
      "Prof. Dr. Savaş Tuna is a pioneer in minimally invasive procedures and has conducted extensive research in gastrointestinal diseases.",
    hospital: "Acıbadem Healthcare Group, Istanbul",
    country: "Turkey",
  },
  {
    id: "tijen-bozkaya",
    name: "Prof Tijen Alkan Bozkaya",
    specialty: "Internal Medicine",
    experience: "28",
    image: "/images/image copy 37.png",
    description:
      "Renowned for her work in chronic disease and metabolic disorder management.",
    qualifications: "MD, PhD in Internal Medicine",
    about:
      "Prof. Bozkaya is widely recognized for her clinical excellence and has authored multiple international publications.",
    hospital: "Medipol Mega University Hospital, Istanbul",
    country: "Turkey",
  },
  {
    id: "remzi-saglam",
    name: "Prof Dr Remzi Saglam",
    specialty: "Urology",
    experience: "30",
    image: "/images/image copy 38.png",
    description:
      "Specialist in endoscopic and reconstructive urologic surgeries.",
    qualifications: "MD, Fellowship in Urology",
    about:
      "Dr. Remzi Saglam is a leading urologist in Turkey with specialization in prostate and kidney treatments.",
    hospital: "Memorial Bahçelievler Hospital, Istanbul",
    country: "Turkey",
  },
  {
    id: "semih-tiber",
    name: "Op Dr Semih Tiber Mentese",
    specialty: "Orthopedics",
    experience: "22",
    image: "/images/image copy 41.png",
    description: "Known for expertise in joint replacement and trauma surgery.",
    qualifications: "MD, Orthopedic Surgery",
    about:
      "Dr. Semih Mentese has performed hundreds of successful orthopedic procedures and is renowned for patient-focused care.",
    hospital: "Liv Hospital, Istanbul",
    country: "Turkey",
  },
  {
    id: "cagri-guneri",
    name: "Assoc Prof Dr Cagri Guneri",
    specialty: "Cardiology",
    experience: "20",
    image: "/images/image copy 40.png",
    description:
      "Highly skilled in interventional cardiology and cardiac imaging.",
    qualifications: "MD, DM (Cardiology)",
    about:
      "Assoc. Prof. Dr. Cagri Guneri is a top expert in non-invasive and invasive cardiology procedures.",
    hospital: "Florence Nightingale Hospital, Istanbul",
    country: "Turkey",
  },
];

const StarDoctorsTurkey = () => {
  const scrollRef = useRef(null);
  const scrollCardWidth = 270;
  const totalDoctors = turkeyDoctors.length;
  const autoScrollTimer = useRef(null);
  const [isUserScrolling, setIsUserScrolling] = useState(false);

  useEffect(() => {
    const container = scrollRef.current;

    const startAutoScroll = () => {
      autoScrollTimer.current = setInterval(() => {
        if (!container || isUserScrolling) return;

        const scrollAmount = scrollCardWidth;
        const maxScrollLeft =
          scrollCardWidth * totalDoctors * 2 - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft - scrollAmount) {
          container.scrollLeft = 0;
        } else {
          container.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }
      }, 3000);
    };

    startAutoScroll();
    return () => clearInterval(autoScrollTimer.current);
  }, [isUserScrolling, totalDoctors]);

  const scroll = (direction) => {
    const container = scrollRef.current;
    const scrollAmount =
      direction === "left" ? -scrollCardWidth : scrollCardWidth;

    const maxScrollLeft =
      scrollCardWidth * totalDoctors * 2 - container.clientWidth;

    setIsUserScrolling(true);
    clearInterval(autoScrollTimer.current);

    if (
      direction === "right" &&
      container.scrollLeft >= maxScrollLeft - scrollCardWidth
    ) {
      container.scrollLeft = 0;
    } else if (direction === "left" && container.scrollLeft <= 0) {
      container.scrollLeft = maxScrollLeft;
    } else {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }

    setTimeout(() => setIsUserScrolling(false), 10000);
  };

  useEffect(() => {
    const container = scrollRef.current;
    let isDown = false;
    let startX, scrollLeft;

    const handleDown = (e) => {
      isDown = true;
      container.classList.add("cursor-grabbing");
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    };

    const handleUp = () => {
      isDown = false;
      container.classList.remove("cursor-grabbing");
    };

    const handleMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2;
      container.scrollLeft = scrollLeft - walk;
    };

    container.addEventListener("mousedown", handleDown);
    container.addEventListener("mouseup", handleUp);
    container.addEventListener("mouseleave", handleUp);
    container.addEventListener("mousemove", handleMove);

    return () => {
      container.removeEventListener("mousedown", handleDown);
      container.removeEventListener("mouseup", handleUp);
      container.removeEventListener("mouseleave", handleUp);
      container.removeEventListener("mousemove", handleMove);
    };
  }, []);

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h3 className="text-4xl font-bold">
            <span className="text-[#1976f2]">Star Doctors </span> of Turkey
          </h3>
          <p className="text-gray-700 text-lg mt-2">
            The most renowned and globally acclaimed doctors
          </p>
        </div>

        <div className="relative">
          <div
            ref={scrollRef}
            className="flex overflow-x-auto gap-6 no-scrollbar px-1 cursor-grab"
            style={{ scrollBehavior: "smooth" }}
          >
            {[...turkeyDoctors, ...turkeyDoctors].map((doc, idx) => (
              <div
                key={idx}
                className="flex-shrink-0 w-[250px] bg-white rounded-lg shadow hover:shadow-md transition p-4 text-center flex flex-col justify-between h-[380px]"
              >
                <img
                  src={doc.image}
                  alt={doc.name}
                  className="rounded-lg mx-auto mb-4 h-40 w-full object-cover"
                />
                <h4 className="text-xl font-semibold mb-1">
                  <Link
                    to={`/doctor-details/${doc.id}`}
                    className="hover:text-[#1976f2]"
                  >
                    {doc.name}
                  </Link>
                </h4>
                <h6 className="text-[#1976f2] font-medium mb-1">
                  {doc.specialty}
                </h6>
                <h5 className="text-gray-600">
                  {doc.experience} Years of Experience
                </h5>
                <div className="mt-3">
                  <Link
                    to={`/doctor-details/${doc.id}`}
                    className="inline-block px-4 py-2 bg-[#1976f2] text-white rounded hover:bg-blue-600 transition"
                  >
                    Book Consultation
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center mt-6 gap-4">
            <button
              onClick={() => scroll("left")}
              className="bg-white border rounded-full p-2 shadow hover:bg-gray-100"
            >
              ◀️
            </button>
            <button
              onClick={() => scroll("right")}
              className="bg-white border rounded-full p-2 shadow hover:bg-gray-100"
            >
              ▶️
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StarDoctorsTurkey;